import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ClearIcon from '@mui/icons-material/Clear';

import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Button,
  Tooltip,
  Typography,
  TextField,
  InputAdornment,

} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { isValidInput } from "../../utils/validations";
import { useLazyGetProductsQuery } from "../../services/products";
import { showError } from "../../constants/toast";
import { ProductData } from "../../types/General";
import { ExportModal2, Pagination } from "../../components";
import Loader from "../../constants/Loader";
import useAuth from "../../hooks/useAuth";
import { Permissions } from "../../types/User";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";


const ManageInventory = () => {
  const [page, setPage] = useState<number>(1)
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [getAllProducts, { isLoading }] = useLazyGetProductsQuery()
  const [product, setProduct] = useState<ProductData[]>([])
  const [open, setOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  let totalPages = Math.ceil(totalCount / 10);
  const navigate = useNavigate();
  const UserData = useAuth();
  const [hidePermission, setHidePermission] = useState<
    Permissions | null | undefined
  >(null);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);

  const handleDateChange = (event: any) => {
    setStartDate(event);
  };

  const handleDateChange1 = (event: any) => {
    setEndDate(event);
  };

  const userPermissions = UserData?.permissions?.length
    ? (UserData?.permissions)
    : [];

  const checkPermission = () => {
    const permission = userPermissions;
    if (permission?.length) {
      let idx = -1;
      idx = permission?.findIndex(
        (ele: Permissions) => ele?.label === "Inventory Management"
      );
      if (idx > -1) {
        setHidePermission(permission[idx]);
      } else {
        navigate(-1);
      }
    }
  };

  const getProducts = async () => {
    try {
      const res = await getAllProducts({
        page: page,
        size: 10,
        query: debouncedSearchTerm.trim(),
        fromDate: startDate ? moment(startDate).format(
          'YYYY-MM-DDTHH:mm:ss[Z]',
        ) : "",
        toDate: endDate ? moment(endDate).format(
          'YYYY-MM-DDTHH:mm:ss[Z]',
        ) : "",
      })
      if (res?.data?.statusCode === 200) {
        setProduct(res?.data?.data?.product || [])
        setTotalCount(res?.data?.data?.count)
      }
    } catch (error: any) {
      showError(error?.data?.message)
    }
  }
  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const label = { inputProps: { "aria-label": "Switch demo" } };
  useEffect(() => {
    getProducts()
  }, [searchTerm, debouncedSearchTerm, page, , startDate, endDate])
  const today = new Date().toISOString().split('T')[0];


  useEffect(() => {
    checkPermission();
  }, [UserData])

  return (
    <div>
      <Loader isLoad={isLoading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">Manage Inventory</h1>
        </div>
        <Card className="cards">
          <Box className="cards_header">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }
              }
            />
            <div>
                <Button
                  sx={{ margin: "5px" }}
                  className="btn btn_primary"
                  onClick={() => setOpen(true)}
                >
                  <FileDownloadIcon /> Export
                </Button>
               
              </div>
          </Box>
          <Box className="crds_date" >
            <div>
              <Typography>Start Date</Typography>
            
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  value={startDate}
                  className="adapter_picker"
                  onChange={handleDateChange}
                />
              </LocalizationProvider>
            </div>
            <div>
              <Typography>End Date</Typography>

              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  value={endDate}
                  className="adapter_picker"
                  onChange={handleDateChange1}

                />
              </LocalizationProvider>
            </div>
            {startDate || endDate ? (
              <Button
                onClick={() => { setStartDate(null); setEndDate(null) }}
                style={{ marginLeft: "1%", borderRadius: "25px", background: "gray",marginTop:"2%" }}
                className="btn btn_primary">Clear</Button>
            ) : ("")}
          </Box>
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.no</TableCell>
                  <TableCell align="center">Product Image</TableCell>
                  <TableCell align="center">Product Name</TableCell>
                  <TableCell align="center">Variants</TableCell>
                  <TableCell align="center">Category</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              {product?.length ? (
                product.map((row, i) => (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center">{(page - 1) * 10 + i + 1}</TableCell>
                      <TableCell align="center">
                        <figure className="user_img">
                          <img src={row?.images[0]?.type === "image" ? (row.images[0].src) : (row?.images[0]?.thumbnailUrl)} alt="" />
                        </figure>
                      </TableCell>
                      <TableCell align="center">{row?.name}</TableCell>
                      <TableCell align="center"><Button
                        className="btn btn_primary"
                        onClick={() => navigate(`/inventory-management/details/variants/${row?._id}`)} >View</Button></TableCell>
                      <TableCell align="center">{row?.category?.name}</TableCell>

                      <TableCell align="center">
                        <Box className="table_actions">
                          <Tooltip title="View">
                            <IconButton
                              onClick={() => navigate(`/inventory-management/details/${row?._id}`)}
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ))
              ) : (
                <TableBody>
                  <TableCell
                    align="center"
                    colSpan={10}
                    sx={{ color: "#051140" }}
                  >

                    No Products Found
                  </TableCell>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Card>
        <Pagination
          module={product}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      </div>
      <ExportModal2
        open={open}
        setOpen={setOpen}
      />
    </div>
  );
};

export default ManageInventory;
